module.exports = __webpack_public_path__ + "img/pin-red.2a67c982.svg";